import { render, staticRenderFns } from "./UpdateAddressModal.vue?vue&type=template&id=3699a73c&scoped=true"
import script from "./UpdateAddressModal.vue?vue&type=script&lang=js"
export * from "./UpdateAddressModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAddressModal.vue?vue&type=style&index=0&id=3699a73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699a73c",
  null
  
)

export default component.exports